import { makeStyles } from "@material-ui/core/styles";

export const useStyle = makeStyles({
  root: {
    display: "inline-flex"
  }
});
